import { useQuery } from "@tanstack/react-query";
import { getCustomerMembers } from "controller/api/customer/customerMembers";
import { generateQueryKey } from "controller/cache/helpers/queryKeyGenerator";
import type { CustomerMembersResponse } from "shared";

/**
 * Query key helpers for customer members
 */
export const customerMembersKeys = {
  all: () => generateQueryKey({ entity: "customer-members" }),
  list: (customerId: string, searchQuery?: string) =>
    generateQueryKey({
      entity: "customer-members",
      operation: "list",
      filters: { customerId, searchQuery },
    }),
};

/**
 * Fetch all members (resources + portal users) for a customer.
 * Used in ChatMembersDrawer to show available members to add.
 *
 * @param customerId - The customer mapping ID
 * @param searchQuery - Optional search to filter server-side
 * @param enabled - Whether the query should run
 */
export const useGetCustomerMembers = (
  customerId: string,
  searchQuery?: string,
  enabled?: boolean,
) => {
  return useQuery<CustomerMembersResponse, Error>({
    queryKey: customerMembersKeys.list(customerId, searchQuery),
    queryFn: () =>
      getCustomerMembers({
        customerId,
        searchQuery: searchQuery || undefined,
      }),
    enabled: enabled !== undefined ? enabled : Boolean(customerId),
  });
};
